import { useEffect } from "react"
import { Navigate, useParams } from "react-router-dom"
import { CircularProgress, makeStyles } from "@material-ui/core"
import { AssetValidation, ContactSupport, HiredateValidation } from "../components"
import { useAppDispatch, useAppSelector } from "../redux/hooks"
import { verifyAPICall } from "../redux/reducers/newHire"
import { appInsights } from "../config"
import LanguageSelector from "../components/LanguageSelector"

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'left',
        alignItems: 'center',
    },
    contactSupport: {
        alignSelf: 'flex-end',
        marginTop: '50px',
        marginRight: '5%',
        marginBottom: '4%',
    }
}))

const Verify = () => {
    const dispatch = useAppDispatch()
    const { verifyDetails, errorMessage, errorCode, password } = useAppSelector(state => state.newHire)
    // useParams() is reliable here; useMatch('/verify/:id') can be null (basename, gateway path, RR6 pattern) → undefined.id crash.
    const { id: verifyIdFromRoute } = useParams<{ id: string }>()
    const classes = useStyles()
    appInsights.trackPageView({ name: 'VerifyAssetLabelPage' })

    useEffect(() => {
        if (!verifyIdFromRoute) {
            return
        }
        dispatch(verifyAPICall(verifyIdFromRoute))
    }, [dispatch, verifyIdFromRoute])

    if (!verifyIdFromRoute?.trim()) {
        return (
            <div className={classes.root}>
                <Navigate to="/error" replace />
                <div>
                    <LanguageSelector />
                </div>
            </div>
        )
    }

    const renderContent = (): JSX.Element => {
        if (
            errorCode === "ASSET_VALIDATE_EXCEEDED" ||
            errorCode === "HIRE_DATE_VALIDATE_EXCEEDED" ||
            errorCode === "PASSWORD_DISPLAY_EXCEEDED"
        ) {
            return <Navigate to="/error" />
        }
        // if password is successfully retrieved show it to user
        if (verifyDetails.isVerified && password !== "" && password.length > 2) {
            return <Navigate to="/show/password" />
        }
        // if all good show serial number validation component

        if (verifyDetails.isVerified && verifyDetails.isInternal) {
            return (
                <>
                    <AssetValidation />
                    <div className={classes.contactSupport}>
                        <ContactSupport />
                    </div>
                </>
            )
        }
        else if (verifyDetails.isVerified && !verifyDetails.isInternal) {
            return (
                <>
                    <HiredateValidation />
                    <div className={classes.contactSupport}>
                        <ContactSupport />
                    </div>
                </>
            )
        }
        // if API call failed redirect to Error page
        if (errorMessage !== null) {
            return <Navigate to="/error" />
        }

        // if API call is in progress show progress bar
        return <CircularProgress style={{ marginTop: '15%' }} />
    }

    return (
        <div className={classes.root}>
            {renderContent()}
            <div>
                <LanguageSelector />
            </div>
        </div>
        
    )
}

export default Verify